function Dipesppresupuestopublico(){
return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Presupuesto Público ha sido diseñado para 
                    brindar conocimientos técnicos y normativos actualizados sobre el Sistema 
                    Nacional de Presupuesto, fortaleciendo las competencias necesarias para 
                    programar, formular, ejecutar y evaluar el gasto público bajo un enfoque de resultados.
               </p>
               <p>
                    El programa desarrolla contenidos vinculados a la programación multianual, 
                    formulación presupuestaria, modificaciones presupuestales, ejecución del gasto, 
                    control y seguimiento, promoviendo una gestión eficiente, transparente y 
                    alineada a los objetivos institucionales.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas en los participantes para gestionar 
                            eficientemente el presupuesto público en sus distintas fases, aplicando 
                            la normativa vigente y herramientas modernas de planificación y control.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_finanzas_publicas.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Sistema Nacional de Presupuesto </li>
                    <li> 2. Programación Multianual </li>
                    <li> 3. Formulación Presupuestaria </li>
                    <li> 4. Modificaciones Presupuestales </li>
                    <li> 5. Ejecución del Gasto Público </li>
                    <li> 6. Control y Seguimiento Presupuestal </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipesppresupuestopublico
